'use client';

import { useEffect, useRef } from 'react';

const USE_LOCAL_VIDEO = true;

const LOCAL_VIDEO = '/assets/videos/home-trek.mp4';
const REMOTE_VIDEO =
  'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260328_083109_283f3553-e28f-428b-a723-d639c617eb2b.mp4';

const FADE_DURATION = 0.5;

export default function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const rafRef = useRef<number>(0);

  const VIDEO_SRC = USE_LOCAL_VIDEO ? LOCAL_VIDEO : REMOTE_VIDEO;

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const tick = () => {
      if (!video.duration || isNaN(video.duration)) {
        rafRef.current = requestAnimationFrame(tick);
        return;
      }

      const t = video.currentTime;
      const d = video.duration;

      if (t < FADE_DURATION) {
        video.style.opacity = String(t / FADE_DURATION);
      } else if (t > d - FADE_DURATION) {
        video.style.opacity = String(Math.max(0, (d - t) / FADE_DURATION));
      } else {
        video.style.opacity = '1';
      }

      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return (
    <div data-component-id="src/app/components/HeroSection.tsx:49:4" data-component-path="src/app/components/HeroSection.tsx" data-component-line="49" data-component-end-line="145" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20min-h-screen%20w-full%20overflow-hidden%20bg-white%22%7D" className="relative min-h-screen w-full overflow-hidden bg-white">

      {/* VIDEO */}
      <div data-component-id="src/app/components/HeroSection.tsx:52:6" data-component-path="src/app/components/HeroSection.tsx" data-component-line="52" data-component-end-line="74" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-x-0%20bottom-0%20overflow-hidden%22%7D"
        className="absolute inset-x-0 bottom-0 overflow-hidden"
        style={{ top: '300px' }}
      >
        <video data-component-id="src/app/components/HeroSection.tsx:56:8" data-component-path="src/app/components/HeroSection.tsx" data-component-line="56" data-component-end-line="65" data-component-file="HeroSection.tsx" data-component-name="video" data-component-content="%7B%22elementName%22%3A%22video%22%2C%22src%22%3A%22%5Bvar%3AVIDEO_SRC%5D%22%2C%22className%22%3A%22absolute%20top-0%20left-0%20w-full%20h-full%20object-cover%20opacity-100%22%7D"
          ref={videoRef}
          src={VIDEO_SRC}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="absolute top-0 left-0 w-full h-full object-cover opacity-100"
        />

        <div data-component-id="src/app/components/HeroSection.tsx:67:8" data-component-path="src/app/components/HeroSection.tsx" data-component-line="67" data-component-end-line="73" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%22%7D"
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'linear-gradient(to bottom, #ffffff 0%, rgba(255,255,255,0) 40%, rgba(255,255,255,0) 60%, #ffffff 100%)',
          }}
        />
      </div>

      {/* CONTENT */}
      <section data-component-id="src/app/components/HeroSection.tsx:77:6" data-component-path="src/app/components/HeroSection.tsx" data-component-line="77" data-component-end-line="144" data-component-file="HeroSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20z-10%20flex%20flex-col%20items-center%20text-center%20px-6%20pb-40%20pt-32%22%7D" className="relative z-10 flex flex-col items-center text-center px-6 pb-40 pt-32">

        {/* HEADING → INSTRUMENT SERIF */}
        <h1 data-component-id="src/app/components/HeroSection.tsx:80:8" data-component-path="src/app/components/HeroSection.tsx" data-component-line="80" data-component-end-line="100" data-component-file="HeroSection.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22textContent%22%3A%22Stop%20%20%20Start%20the%22%7D"
          style={{
            fontFamily: 'Instrument Serif, serif',
            fontWeight: 400,
            fontSize: 'clamp(3.2rem, 8vw, 6.5rem)',
            lineHeight: 0.92,
            letterSpacing: '-2.5px',
            color: '#000000',
            maxWidth: '1100px',
          }}
        >
          Stop{' '}
          <span data-component-id="src/app/components/HeroSection.tsx:92:10" data-component-path="src/app/components/HeroSection.tsx" data-component-line="92" data-component-end-line="94" data-component-file="HeroSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Dreaming%2C%22%7D" style={{ color: '#6F6F6F', fontStyle: 'italic' }}>
            Dreaming,
          </span>
          <br data-component-id="src/app/components/HeroSection.tsx:95:10" data-component-path="src/app/components/HeroSection.tsx" data-component-line="95" data-component-end-line="95" data-component-file="HeroSection.tsx" data-component-name="br" data-component-content="%7B%22elementName%22%3A%22br%22%7D" />
          Start the{' '}
          <span data-component-id="src/app/components/HeroSection.tsx:97:10" data-component-path="src/app/components/HeroSection.tsx" data-component-line="97" data-component-end-line="99" data-component-file="HeroSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Journey.%22%7D" style={{ color: '#6F6F6F', fontStyle: 'italic' }}>
            Journey.
          </span>
        </h1>

        {/* DESCRIPTION → SANS */}
        <p data-component-id="src/app/components/HeroSection.tsx:103:8" data-component-path="src/app/components/HeroSection.tsx" data-component-line="103" data-component-end-line="116" data-component-file="HeroSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22textContent%22%3A%22Himalayan%20Treks%20%26%20Flights%20Available%20Now%22%7D"
          style={{
            fontFamily: 'system-ui, sans-serif',
            color: '#6F6F6F',
            marginTop: '28px',
            fontSize: '18px',
            fontWeight: 300,
            letterSpacing: '0.2px',
            lineHeight: 1.6,
            maxWidth: '520px',
          }}
        >
          Himalayan Treks & Flights Available Now
        </p>

        {/* BUTTON → SANS */}
        <button data-component-id="src/app/components/HeroSection.tsx:119:8" data-component-path="src/app/components/HeroSection.tsx" data-component-line="119" data-component-end-line="142" data-component-file="HeroSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22Book%20Your%20Adventure%20Now%22%7D"
          style={{
            marginTop: '44px',
            padding: '18px 44px',
            background: '#000000',
            color: '#FFFFFF',
            borderRadius: '999px',
            border: 'none',
            fontFamily: 'system-ui, sans-serif',
            fontSize: '15px',
            fontWeight: 400,
            letterSpacing: '0.4px',
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
          }}
          onMouseEnter={(e) =>
            ((e.currentTarget as HTMLElement).style.transform = 'scale(1.04)')
          }
          onMouseLeave={(e) =>
            ((e.currentTarget as HTMLElement).style.transform = 'scale(1)')
          }
        >
          Book Your Adventure Now
        </button>

      </section>
    </div>
  );
}